// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ECharts from 'vue-echarts/components/ECharts.vue'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
// import './assets/js/validate.js';
import App from './App'
import router from './router'
// import Vuex from 'vuex'
// import store from './store'
import Element from 'element-ui'
import _ from 'lodash'
import 'element-ui/lib/theme-default/index.css'
import './assets/css/normalize.css'
import './assets/css/base.css'
import axios from 'axios'
// import VueCookie from 'vue-cookie';
// import './assets/global.css'


Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.prototype._ = _
// Vue.use(Vuex);
Vue.use(Element);
Vue.component('chart', ECharts)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js